/**
 * Label do provider social usado no composer/fila de publicação do Channel Dashboard
 * (`PostComposer`, `ScheduledQueue`) — canais `facebook-messenger` publicam em Página do
 * Facebook, os demais canais sociais suportados hoje publicam no Instagram.
 *
 * Fonte única para a checagem `providerId === 'facebook-messenger'` — evita duplicar a
 * mesma expressão em cada componente que precisa do label pro toast/confirm de publicação.
 */
export function getProviderLabel(providerId: string | undefined): 'Facebook' | 'Instagram' {
  return providerId === 'facebook-messenger' ? 'Facebook' : 'Instagram';
}
